module.exports = __webpack_public_path__ + "media/packs/images/flags/CM-b07e3f206ea6ad50c1bbac550c7cecdb.png";